const componentTypeQueryKeys = {
    components: ['components'],
    componentType: (componentId: string) => [`components`, componentId],
};

export default componentTypeQueryKeys;
